<template>
  <v-text-field
    autocomplete="off"
    reverse
    @blur="emitValue()"
    v-model="numberValue"
    :label="label"
    :disabled="disabled"
  ></v-text-field>
</template>

<script>
const numberRegex = /(?<number>-?\d+(\s*\d+)*(\.\d{0,2})?)/;

export default {
  props: {
    label: {
      type: String,
      default: "Number",
    },
    value: {
      type: Number,
      default: 0,
    },
    minValue: {
      type: Number,
      default : 0
    },
    maxValue: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    if (this.value) {
      this.numberValue = this.parseValue(this.value)
      return;
    }
  },
  data: () => ({
    numberValue: 0
  }),
  methods: {
    parseValue(valueStr) {
      const parsed = numberRegex.exec(valueStr.toString().trim());
      if (!parsed) {
        return 0;
      }
      let num = parseFloat(parsed.groups["number"]);
      if (num > this.maxValue) {
        num = this.maxValue;
      }
      if (num < this.minValue) {
        num = this.minValue;
      }
      return num;
    },
    emitValue() {
      if (this.numberValue === "") {
        this.numberValue = 0;
      }
      else {
        this.numberValue = this.parseValue(this.numberValue);
      }      
      this.$emit("onNumber", this.numberValue);
    },   
  },
  watch: {
    value() {
      this.numberValue = this.parseValue(this.value);
    }
  }  
};
</script>